export default [
  { path: '/', name: 'Home', view: 'Home', text: 'Dashboard' },
  { path: '/action/advising', name: 'AdvisingSchedule', view: 'Action/AdvisingSchedule' },
  { path: '/action/completed/:action', name: 'CompletedAction', view: 'Action/Completed' },
  { path: '/action/language', name: 'LanguageSample', view: 'Action/Language' },
  { path: '/action/pre-register', name: 'PreRegister', view: 'Action/Preregister' },
  { path: '/action/writing', name: 'WritingUpload', view: 'Action/Writing' },
  { path: '/admin', name: 'AdminDashboard', view: 'Admin/Dashboard' },
  { path: '/admin/terms', name: 'AdminTermManager', view: 'Admin/Terms' },
  { path: '/admin/advising/schedule', name: 'AdminAdvisingSchedule', view: 'Admin/Advising/Schedule' },
  { path: '/admin/advising/student/:id', name: 'AdminAdvisingStudent', view: 'Admin/Advising/Student' },
  { path: '/admin/tracker', name: 'AdminTracker', view: 'Admin/Tracker/List' },
  { path: '/admin/tracker/email-log', name: 'AdminTrackerEmailLog', view: 'Admin/Tracker/Log/List' },
  { path: '/admin/tracker/email-log/:id', name: 'AdminTrackerEmailLogView', view: 'Admin/Tracker/Log/View' },
  { path: '/admin/tracker/email-template', name: 'AdminTrackerTemplate', view: 'Admin/Tracker/Template/List' },
  { path: '/admin/tracker/email-template/:id', name: 'AdminTrackerTemplateEdit', view: 'Admin/Tracker/Template/Edit' },
  { path: '/admin/tracker/:id', name: 'AdminTrackerView', view: 'Admin/Tracker/View' },
  { path: '/admin/sections', name: 'AdminSectionList', view: 'Admin/SectionList' },
  { path: '/admin/slides/:section', name: 'AdminSlideManager', view: 'Admin/SlideManager' },
  { path: '/admin/preview/:section/:slide(\\d+)?', name: 'AdminPreview', view: 'Admin/Preview' },
  { path: '/profile/reset', name: 'ParentPasswordReset', view: 'Profile/Reset' },
  { path: '/profile', name: 'ParentProfile', view: 'Profile/Form' },
  { path: '/setup', name: 'AccountSetup', view: 'Setup' },
  { path: '/:section/:slide(\\d+)?', name: 'Slides', view: 'Slides' }
]
